/**
 * Vehicle Selector – API-powered cascading dropdowns
 * Data source: https://scsbiz.wearevisum.com/api/v1/years
 */
(function () {
  var API_BASE = 'https://vehicle-selector-api.tieudigi.workers.dev/api/v1/years';
  var PARAMS = 'type=normal&with_sales=yes';
  var STORAGE_KEY = 'vehicleSelection';
  var STORAGE_TTL = 7 * 24 * 60 * 60 * 1000;
  var HAS_ABORT = typeof AbortController !== 'undefined';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var yearSelect = document.getElementById('vehicle-year');
    var makeSelect = document.getElementById('vehicle-make');
    var modelSelect = document.getElementById('vehicle-model');
    var trimSelect = document.getElementById('vehicle-trim');
    var cabSelect = document.getElementById('vehicle-cab');
    var validationMessage = document.getElementById('vehicle-validation-message');
    var trimWrapper = document.getElementById('trim-wrapper');
    var cabWrapper = document.getElementById('cab-wrapper');
    var validationFrame = null;

    if (!yearSelect) return;

    var cachedData = null;

    // ── Active fetch controllers (for cancellation) ──
    var bgMakesController = null;
    var modelController = null;

    // ── Helpers ──
    function createChangeEvent() {
      if (typeof Event === 'function') {
        return new Event('change', { bubbles: true });
      }
      var evt = document.createEvent('Event');
      evt.initEvent('change', true, true);
      return evt;
    }

    function abortController(ctrl) {
      if (ctrl) { try { ctrl.abort(); } catch (e) { /* ignore */ } }
      return null;
    }

    function newController(timeoutMs) {
      if (!HAS_ABORT) return { controller: null, clear: function () { } };
      var ctrl = new AbortController();
      var tid = setTimeout(function () { ctrl.abort(); }, timeoutMs);
      return {
        controller: ctrl,
        clear: function () { clearTimeout(tid); }
      };
    }

    function resetSelect(sel, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      sel.disabled = true;
    }

    var TOP_SELLERS = ['Ford', 'Ram', 'Chevrolet', 'GMC', 'Dodge', 'Toyota'];

    function populateSelect(sel, items, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      items.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item;
        opt.textContent = item;
        sel.appendChild(opt);
      });
      sel.disabled = items.length === 0;
    }

    function populateMakeSelect(sel, allMakes, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';

      var topItems = [];
      var otherItems = [];

      allMakes.forEach(function (make) {
        if (TOP_SELLERS.indexOf(make) !== -1) {
          topItems.push(make);
        } else {
          otherItems.push(make);
        }
      });

      topItems.sort(function (a, b) {
        return TOP_SELLERS.indexOf(a) - TOP_SELLERS.indexOf(b);
      });

      if (topItems.length > 0) {
        var grp1 = document.createElement('optgroup');
        grp1.label = 'Top Sellers';
        topItems.forEach(function (make) {
          var opt = document.createElement('option');
          opt.value = make;
          opt.textContent = make;
          grp1.appendChild(opt);
        });
        sel.appendChild(grp1);
      }

      if (otherItems.length > 0) {
        var grp2 = document.createElement('optgroup');
        grp2.label = 'All Others';
        otherItems.forEach(function (make) {
          var opt = document.createElement('option');
          opt.value = make;
          opt.textContent = make;
          grp2.appendChild(opt);
        });
        sel.appendChild(grp2);
      }

      sel.disabled = allMakes.length === 0;
    }

    var MODEL_TOP_COUNTS = {
      'Ford': 4,
      'Ram': 3,
      'Chevrolet': 4,
      'GMC': 4,
      'Dodge': 3,
      'Toyota': 3
    };

    function populateModelSelect(sel, allModels, placeholder, make) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';

      if (allModels.length === 0) {
        sel.disabled = true;
        return;
      }

      var topCount = MODEL_TOP_COUNTS[make] || 0;

      if (topCount > 0 && topCount < allModels.length) {
        var topModels = allModels.slice(0, topCount);
        var otherModels = allModels.slice(topCount);

        var grp1 = document.createElement('optgroup');
        grp1.label = 'Top Sellers';
        topModels.forEach(function (model) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          grp1.appendChild(opt);
        });
        sel.appendChild(grp1);

        var grp2 = document.createElement('optgroup');
        grp2.label = 'All Others';
        otherModels.forEach(function (model) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          grp2.appendChild(opt);
        });
        sel.appendChild(grp2);
      } else {
        allModels.forEach(function (model) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          sel.appendChild(opt);
        });
      }

      sel.disabled = false;
    }

    function showLoading(sel) {
      sel.innerHTML = '<option value="">Loading...</option>';
      sel.disabled = true;
    }

    // ── Storage helpers (localStorage + 7-day TTL) ──
    function saveSelection() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          year: yearSelect.value, make: makeSelect.value,
          model: modelSelect.value, submodel: trimSelect.value,
          cab: cabSelect.value, ts: Date.now()
        }));
      } catch (e) { /* Edge case #6: Incognito / quota exceeded */ }
    }

    function loadSelection() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (Date.now() - data.ts > STORAGE_TTL) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        return data;
      } catch (e) { return null; }
    }

    function clearSelection() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* silent */ }
    }

    // ── Static cache: Years (generated) & Makes (from API snapshot) ──
    var STATIC_MAKES = [
      'Ford','Ram','Chevrolet','GMC','Dodge','Toyota',
      'Acura','Audi','BMW','BYD','Buick','Cadillac','Chery','Chrysler',
      'GWM','Genesis','Haval','Honda','Hyundai','Infiniti','Isuzu','Jaguar','Jeep',
      'Kia','LDV','Land Rover','Lexus','Lincoln','Lucid','MG','Mahindra',
      'Maserati','Mazda','Mercedes','Mini','Mitsubishi','Nissan','Polestar',
      'Renault','Ssangyong','Subaru','Suzuki','Volkswagen','Volvo'
    ];

    function generateYears() {
      var years = [];
      for (var y = 2026; y >= 1998; y--) {
        years.push(String(y));
      }
      return years;
    }

    // ── Step 1: Load Years (instant – no API call) ──
    populateSelect(yearSelect, generateYears(), 'Select Year');

    // ── Year change → populate Makes (instant from static list) ──
    yearSelect.addEventListener('change', function () {
      var year = this.value;

      // Cancel any pending fetches
      bgMakesController = abortController(bgMakesController);
      modelController = abortController(modelController);

      resetSelect(makeSelect, 'Select Make');
      resetSelect(modelSelect, 'Select Model');
      resetSelect(trimSelect, 'Select Submodel');
      resetSelect(cabSelect, 'Select Cab Size');
      if (trimWrapper) trimWrapper.style.display = 'none';
      if (cabWrapper) cabWrapper.style.display = 'none';
      cachedData = null;

      if (!year) { validateAndSyncSteps(); return; }

      // Populate instantly with static makes – no API needed
      populateMakeSelect(makeSelect, STATIC_MAKES, 'Select Make');
      validateAndSyncSteps();

      // Background refresh only if AbortController is available (skip on old iOS)
      if (HAS_ABORT) {
        var bg = newController(5000);
        bgMakesController = bg.controller;

        fetch(API_BASE + '?year=' + encodeURIComponent(year) + '&' + PARAMS, { signal: bg.controller.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            bg.clear();
            bgMakesController = null;
            if (data.makes && data.makes.length > 0 && !makeSelect.value) {
              var filteredMakes = data.makes.filter(function(m) { return m !== 'Tesla'; });
              populateMakeSelect(makeSelect, filteredMakes, 'Select Make');
            }
          })
          .catch(function () {
            bg.clear();
            bgMakesController = null;
          });
      }
    });

    // ── Make change → load Models from API ──
    makeSelect.addEventListener('change', function () {
      var make = this.value;
      var year = yearSelect.value;

      // Cancel background makes fetch to free connection for model fetch
      bgMakesController = abortController(bgMakesController);
      // Cancel any previous model fetch
      modelController = abortController(modelController);

      resetSelect(modelSelect, 'Select Model');
      resetSelect(trimSelect, 'Select Submodel');
      resetSelect(cabSelect, 'Select Cab Size');
      if (trimWrapper) trimWrapper.style.display = 'none';
      if (cabWrapper) cabWrapper.style.display = 'none';
      cachedData = null;

      if (!make) { validateAndSyncSteps(); return; }

      showLoading(modelSelect);

      // Fetch with 10s timeout
      var mc = newController(10000);
      modelController = mc.controller;

      fetch(API_BASE + '?year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make) + '&' + PARAMS, mc.controller ? { signal: mc.controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          mc.clear();
          modelController = null;
          cachedData = data;
          var models = data.models ? Object.keys(data.models) : [];
          populateModelSelect(modelSelect, models, 'Select Model', make);
          validateAndSyncSteps();
        })
        .catch(function () {
          mc.clear();
          modelController = null;
          resetSelect(modelSelect, 'Select Model');
          validateAndSyncSteps();
        });
    });

    // ── Model change → show Trims from cached data ──
    modelSelect.addEventListener('change', function () {
      var model = this.value;
      resetSelect(trimSelect, 'Select Submodel');
      resetSelect(cabSelect, 'Select Cab Size');
      if (trimWrapper) trimWrapper.style.display = 'none';
      if (cabWrapper) cabWrapper.style.display = 'none';

      if (!model || !cachedData) { validateAndSyncSteps(); return; }

      var trims2 = cachedData.trims2 || {};
      var trimEntries = trims2[model] || [];

      if (trimEntries.length > 0) {
        var uniqueTrims = [];
        var seen = {};
        trimEntries.forEach(function (entry) {
          if (entry.trim && !seen[entry.trim]) {
            uniqueTrims.push(entry.trim);
            seen[entry.trim] = true;
          }
        });

        if (uniqueTrims.length > 0) {
          populateSelect(trimSelect, uniqueTrims, 'Select Submodel');
          if (trimWrapper) trimWrapper.style.display = 'block';
        }
      }

      validateAndSyncSteps();
    });

    // ── Trim change → show Cab Sizes from cached data ──
    trimSelect.addEventListener('change', function () {
      var trim = this.value;
      var model = modelSelect.value;
      resetSelect(cabSelect, 'Select Cab Size');
      if (cabWrapper) cabWrapper.style.display = 'none';

      if (!trim || !model || !cachedData) { validateAndSyncSteps(); return; }

      var trims2 = cachedData.trims2 || {};
      var trimEntries = trims2[model] || [];

      var cabs = [];
      var seenCab = {};
      trimEntries.forEach(function (entry) {
        if (entry.trim === trim && entry.cab && entry.cab !== '' && !seenCab[entry.cab]) {
          cabs.push(entry.cab);
          seenCab[entry.cab] = true;
        }
      });

      if (cabs.length > 0) {
        populateSelect(cabSelect, cabs, 'Select Cab Size');
        if (cabWrapper) cabWrapper.style.display = 'block';
      }

      validateAndSyncSteps();
    });

    cabSelect.addEventListener('change', function () { validateAndSyncSteps(); });

    // ── Validation & Stepper Sync ──
    function runValidateAndSyncSteps() {
      var trimRequired = trimWrapper && trimWrapper.style.display !== 'none' && !trimSelect.disabled && trimSelect.options.length > 1;
      var cabRequired = cabWrapper && cabWrapper.style.display !== 'none' && !cabSelect.disabled && cabSelect.options.length > 1;

      var vehicleDone = yearSelect.value && makeSelect.value && modelSelect.value
        && (!trimRequired || trimSelect.value)
        && (!cabRequired || cabSelect.value);

      var colorPicker = document.querySelector('.product-color-picker');
      var setupPicker = document.querySelector('.product-setup-picker');
      var colorSelected = colorPicker ? colorPicker.querySelector('input:checked') : true;
      var setupSelected = setupPicker ? setupPicker.querySelector('input:checked') : true;

      var allDone = vehicleDone && colorSelected && setupSelected;

      var step1 = document.getElementById('step-1-container');
      var step2 = document.getElementById('step-2-container');
      var step3 = document.getElementById('step-3-container');

      if (vehicleDone) {
        if (step1) step1.classList.add('completed');
        if (step2) step2.classList.add('active');
        if (validationMessage) validationMessage.style.display = 'none';
      } else {
        if (step1) step1.classList.remove('completed');
        if (step2) step2.classList.remove('active');
        if (step3) step3.classList.remove('active');
        if (validationMessage && yearSelect.value) validationMessage.style.display = 'block';
      }

      if (vehicleDone && colorSelected) {
        if (step2) step2.classList.add('completed');
        if (step3) step3.classList.add('active');
      } else {
        if (step2) step2.classList.remove('completed');
        if (step3) step3.classList.remove('active');
      }

      if (allDone) {
        if (step3) step3.classList.add('completed');
      } else {
        if (step3) step3.classList.remove('completed');
      }

      var atcButtons = document.querySelectorAll('.m-add-to-cart');
      Array.prototype.forEach.call(atcButtons, function (btn) {
        if (allDone) {
          btn.setAttribute('data-steps-complete', 'true');
          btn.style.opacity = '1';
        } else {
          btn.setAttribute('data-steps-complete', 'false');
          btn.style.opacity = '0.7';
        }
      });

      // Edge case #7: clear storage when all reset, save otherwise
      if (yearSelect.value) { saveSelection(); } else { clearSelection(); }
    }

    function validateAndSyncSteps() {
      if (validationFrame) return;

      validationFrame = requestAnimationFrame(function () {
        validationFrame = null;
        runValidateAndSyncSteps();
      });
    }

    function isConfigurationComplete() {
      var trimRequired = trimWrapper && trimWrapper.style.display !== 'none' && !trimSelect.disabled && trimSelect.options.length > 1;
      var cabRequired = cabWrapper && cabWrapper.style.display !== 'none' && !cabSelect.disabled && cabSelect.options.length > 1;

      var vehicleDone = yearSelect.value && makeSelect.value && modelSelect.value
        && (!trimRequired || trimSelect.value)
        && (!cabRequired || cabSelect.value);

      var colorPicker = document.querySelector('.product-color-picker');
      var setupPicker = document.querySelector('.product-setup-picker');
      var colorSelected = colorPicker ? colorPicker.querySelector('input:checked') : true;
      var setupSelected = setupPicker ? setupPicker.querySelector('input:checked') : true;
      return vehicleDone && colorSelected && setupSelected;
    }

    // ── Listen for Color and Setup changes ──
    document.addEventListener('change', function (e) {
      if (e.target.closest('.product-color-picker') || e.target.closest('.product-setup-picker')) {
        validateAndSyncSteps();
      }
    });

    // ── Intercept ATC clicks if steps aren't complete ──
    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('.m-add-to-cart');
      if (atcBtn) {
        var isComplete = atcBtn.getAttribute('data-steps-complete') === 'true' || isConfigurationComplete();
        if (!isComplete) {
          var stepper = document.querySelector('.vehicle-config-stepper');
          if (stepper) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var offset = 120;
            var elementPosition = stepper.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
          }
        }
      }
    }, true);

    // ── Restore: URL params (priority) → localStorage fallback ──
    function restoreFromURL() {
      var urlParams = new URLSearchParams(window.location.search);
      var pYear = urlParams.get('year');

      // Edge case #5: URL params always override localStorage
      var saved;
      if (pYear) {
        saved = { year: pYear, make: urlParams.get('make') || '', model: urlParams.get('model') || '', submodel: '', cab: '' };
      } else {
        saved = loadSelection();
      }

      if (!saved || !saved.year) return;

      // Edge case #2: if year not in list, skip
      yearSelect.value = saved.year;
      if (!yearSelect.value) return;
      yearSelect.dispatchEvent(createChangeEvent());

      if (!saved.make) return;

      // Edge case #3: cascading restore – poll until each select is ready
      var makePoll = setInterval(function () {
        if (!makeSelect.disabled && makeSelect.options.length > 1) {
          clearInterval(makePoll);
          makeSelect.value = saved.make;
          if (!makeSelect.value) return; // Edge case #2
          makeSelect.dispatchEvent(createChangeEvent());

          if (!saved.model) return;

          var modelPoll = setInterval(function () {
            if (!modelSelect.disabled && modelSelect.options.length > 1) {
              clearInterval(modelPoll);
              modelSelect.value = saved.model;
              if (!modelSelect.value) return;
              modelSelect.dispatchEvent(createChangeEvent());

              // Edge case #8: trim/cab populated synchronously from cachedData
              if (saved.submodel && trimWrapper && trimWrapper.style.display !== 'none' && !trimSelect.disabled && trimSelect.options.length > 1) {
                trimSelect.value = saved.submodel;
                if (trimSelect.value) {
                  trimSelect.dispatchEvent(createChangeEvent());

                  if (saved.cab && cabWrapper && cabWrapper.style.display !== 'none' && !cabSelect.disabled && cabSelect.options.length > 1) {
                    cabSelect.value = saved.cab;
                    if (cabSelect.value) cabSelect.dispatchEvent(createChangeEvent());
                  }
                }
              }
            }
          }, 100);
          setTimeout(function () { clearInterval(modelPoll); }, 10000);
        }
      }, 100);
      setTimeout(function () { clearInterval(makePoll); }, 5000);
    }

    // Restore saved selection (must run AFTER all event listeners are registered)
    restoreFromURL();

    // Initial check
    setTimeout(function () { validateAndSyncSteps(); }, 500);

    if (window.MinimogEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, function () {
        validateAndSyncSteps();
      });
    } else {
      document.addEventListener('variant:changed', function () {
        validateAndSyncSteps();
      });
    }
  }
})();
